@let sidePanelSlot = _taskCrud!.ganttVisible ? 1 : 0;

<div class="mainframe">
    <div class="hcol-flex space-around-between">
        <div class="hcol-flex"></div>
        <div class="hcol-flex gap-half" style="margin-top: -5rem">
            <p-buttongroup>
                <p-button
                    icon="pi pi-table"
                    label="Table"
                    [severity]="_taskCrud!.ganttVisible ? 'secondary' : 'primary'"
                    [outlined]="_taskCrud!.ganttVisible"
                    (click)="_taskCrud!.ganttVisible = false"
                />
                <p-button
                    icon="pi pi-chart-bar"
                    label="Gantt"
                    [severity]="_taskCrud!.ganttVisible ? 'primary' : 'secondary'"
                    [outlined]="!_taskCrud!.ganttVisible"
                    (click)="_taskCrud!.ganttVisible = true"
                />
            </p-buttongroup>

            <p-button
                [icon]="_sidePanelVisible[sidePanelSlot] ? 'pi pi-chevron-circle-right' : 'pi pi-chevron-circle-left'"
                severity="contrast"
                (onClick)="_sidePanelVisible[sidePanelSlot] = !_sidePanelVisible[sidePanelSlot]"
            />
            <p-button label="Create Group" severity="primary" (onClick)="_taskCrud?.onNewGroup()" />
            <p-button label="Create Task" severity="primary" (onClick)="_taskCrud?.onNewTask()" />
        </div>
    </div>
    <div class="hcol-flex gap-half auto-grow">
        <div
            [ngClass]="_sidePanelVisible[sidePanelSlot] ? 'hcol-75' : 'hcol-100'"
            style="max-height: calc(100% - 4.5rem)"
        >
            <app-task-crud
                [showNewButton]="false"
                [(selectedTask)]="_selectedTask"
                [(taskList)]="_tasksTreeItems"
                ($onSelectedReloaded)="_taskDetails?.refresh()"
            ></app-task-crud>
        </div>

        <div [ngClass]="_sidePanelVisible[sidePanelSlot] ? 'hcol-25' : 'hcol-0'">
            <app-ff-accordion>
                <app-ff-accordion-header value="0" label="Task Details" />
                <app-ff-accordion-content value="0">
                    <app-task-details
                        ($selectTaskRequest)="selectTask($event)"
                        ($refreshRequest)="_taskCrud?.refresh()"
                        [currentTaskUUID]="_selectedTask?.data?.uuid"
                        [tasksTreeItems]="_tasksTreeItems"
                    ></app-task-details>
                </app-ff-accordion-content>
                <app-ff-accordion-header value="1" label="Task Chat" />
                <app-ff-accordion-content value="1">
                    <app-task-chat [currentTaskUUID]="_selectedTask?.data?.uuid"></app-task-chat>
                </app-ff-accordion-content>
                <app-ff-accordion-header value="2" label="Task Instructions" />
                <app-ff-accordion-content value="2">
                    <app-task-instructions [currentTaskUUID]="_selectedTask?.data?.uuid"></app-task-instructions>
                </app-ff-accordion-content>
            </app-ff-accordion>
        </div>
    </div>
</div>
